const uuid = () =>
  Math.random()
    .toString(36)
    .substring(3, 8)

export const listCurrentPage = 1
export const listPageSize = 20

const toastOption = {
  // toast相关配置
  toastText: null,
  toastType: 'text',
  toastPosition: 'middle',
  toastTime: 1200,
  showToast: false,
}

const mixinCommon = {
  data () {
    return {
      validMessages: {}, // 校验信息（错误）
      saveFieldList: {}, // 修改字段列表（当字段值变化，会被添加到该列表）
      selectParams: {show: false}, // select的参数
      lookupParams: {show: false}, // lookup的参数
      currentSelect: {}, // 当前的select
      currentLookup: {}, // 当前的lookup
    }
  },
  computed: {
    validMessage () {
      let [first] = Object.keys(this.validMessages)
      return first && this.validMessages[first]
    },
    currentPopup () {
      if(this.selectParams.show) return 'selectParams'
      if(this.lookupParams.show) return 'lookupParams'
      return undefined
    },
  },
  methods: {
    saveHandle (fieldKey, fieldValue) {
      if(fieldValue === undefined) {
        let {[fieldKey]: expectValue, ...tmp} = this.saveFieldList
        this.saveFieldList = tmp
      } else {
        this.saveFieldList = {...this.saveFieldList, [fieldKey]: fieldValue}
      }
    },
    validHandle (fieldKey, validObject) {
      if(validObject === undefined) {
        let {[fieldKey]: expectValue, ...tmp} = this.validMessages
        this.validMessages = tmp
      } else {
        this.validMessages = {...this.validMessages, [fieldKey]: validObject}
      }
    },
    selectHandle (newValue) {
      this.selectParams = {...this.selectParams, show: true, ...newValue}
    },
    lookupHandle (newValue) {
      this.lookupParams = {...this.lookupParams, show: true, ...newValue}
    },
    selectChange (newValue) {
      let {key, label} = newValue
      this.$set(this.responseList, this.selectParams.key, key)
      this.$set(this.responseList, `${this.selectParams.key}_text`, label)
      this.currentSelect = {...newValue}
    },
    lookupChange (newValue) {
      let {key, label} = newValue
      // console.log('newValue--->', JSON.stringify(newValue))
      this.$set(this.responseList, this.lookupParams.key, key)
      this.$set(this.responseList, `${this.lookupParams.key}_text`, label)
      this.currentLookup = {...newValue}
    },
    deleteValid (key) {
      if(!this.isEmpty(this.validMessages[key])) {
        delete this.validMessages[key]
      }
    },
  },
}

const mixinDetail = {
  mixins: [mixinCommon],
  props: {
    id: String,
    initItem: {type: [Number, String], default: 0}, // 初始选项卡
    backStep: [Number, String], // router.go()需要的回退步数
  },
  data () {
    return {
      // 默认值，需要在detail设置相应值
      headerTitle: '客户',
      primaryKey: 'accountid', // 主键，发送更新请求需要主键
      module: 'account', // 模块名，跳转360度视图需要指定
      entityCode: 'account', // 实体编号
      tcode: 'account_detail', // 发请求需要的参数，唯一编码
      editRouter: 'account_edit', // 编辑需要跳转的命名路由

      // 视情况而定，可修改
      canEdit: true, // 该页面是否允许编辑，禁止编辑是通过隐藏编辑按钮来实现

      // 内部变量，不必修改
      responseList: {}, // 详情数据
      relatedViews: [], // 360度视图配置
      timeFlow: [], // 跟进记录（时间流）数据
      tableHeader: [], // 行明细头数据
      tableRows: [], // 行明细行数据
      currentItem: Number.isNaN(Number(this.initItem))
        ? 0
        : Number(this.initItem), // 当前选项卡index
      dataState: $CONST_STRING.DATA_STATE_INITIALIZING, // 数据状态，默认值为常量字符串initializing，表示数据正在初始化，在接收到服务端数据之后变为常量字符串initialized，表示数据初始化完成，之后会进行脏值检查，类型校验，正则校验
      state: $CONST_STRING.STATE_DETAIL, // 该页面的状态，detail，edit，detail表示页面处于详情状态，可能经过编辑，或者是从新建页面跳转过来的，页面的字段只读，edit表示页面处于编辑状态，页面的字段可编辑
      // 页面渲染配置
      ...toastOption, // toast相关配置
      readonly: true, // 只读
      successFlag: false,
    }
  },
  watch: {
    // 将currentItem拼接到 url 上，持久化
    currentItem: {
      handler (newValue) {
        this.$route.query.initItem = newValue
        let fullPath = this.$route.path
        let item = this.$route.query
        let queries = []
        Object.keys(item).forEach(key => {
          queries = queries.concat(`${key}=${item[key]}`)
        })
        history.replaceState(
          {title: 'item-onchange'},
          'item-onchange',
          `#${fullPath}?${queries.join('&')}`
        )
      },
      immediate: true,
    },
  },
  methods: {
    async init () {
      try {
        let params = {
          tcode: 'quo_maintain',
          id: 'de831d5d-ee25-ea11-a850-0017fa033585',
        }
        await $appForm
          .hdForm(params)
          .then(res => {
            let resData = res.data || {}
            if(resData.code === '10') {
              this.responseList = resData.result
                ? JSON.parse(resData.result)
                : {}
              console.log(JSON.stringify(this.responseList))
            }
          })
          .catch(err => {
            console.error(err)
          })
      } catch (err) {
        console.error(err)
      }
    },
    edit () {
      // 下面这个是支持跳转页面编辑需要的
      this.successFlag = true
      this.$router.push({
        name: this.editRouter,
        query: {
          id: this.id,
          editResponseList: JSON.stringify(this.responseList),
        },
      })
    },
    goRelatedViews (item) {
      console.log(item)
      let key = item.key
      let routerName = `${key}_list`
      let hasNew = item.hasNew || true
      if(item.key === $CONST_STRING.ATTACHMENT) {
        this.$router.push({
          name: routerName,
          query: {
            id: this.id,
            hasNew,
            relatedIdObject: JSON.stringify({
              id: this.id,
              entity: this.module,
            }),
          },
        })
      } else {
        this.$router.push({name: routerName, query: {id: this.id, hasNew}})
      }
    },
    goBack () {
      this.successFlag = true
      const fromName = this.getStoreInfo('RouteStore', 'fromName')
      console.log('fromName1--->', fromName)
      if(this.isEmpty(fromName)) {
        window.vm.wx.closeWindow()
      } else {
        this.$router.back()
      }
    },
    // 检验当前用户是否是单据负责人ownerid
    async loginUserIsOwner () {
      // 获取当前用户
      let data = this.getLocalValue('currentUserInfo')
      this.$loading.hide()
      // 检验当前用户是否是单据负责人ownerid，如果不相等或者负责人字段为空，提示“只有负责人有权限赢丢单”
      return (
        !this.isEmpty(this.responseList.ownerid) &&
        data.id === this.responseList.ownerid
      )
    },
  },
  beforeRouteLeave (to, from, next) {
    if(this.successFlag) {
      this.successFlag = false
      next()
      return
    }
    next(false)
    this.goBack()
  },
}

const mixinNew = {
  mixins: [mixinCommon],
  props: {
    relatedIdObject: Object,
  },
  data () {
    return {
      // 默认值，需要在new设置相应值
      headerTitle: '客户',
      entityCode: 'account', // 实体编号
      tcode: 'account_detail', // 发请求需要的参数，唯一编码
      detailRouter: 'account_detail', // 新建后跳转的命名路由
      params: {}, // 新建初始化需要的参数

      // 内部变量，不必修改
      dataState: $CONST_STRING.DATA_STATE_INITIALIZING,
      responseList: {},
      extraResponseList: {}, // 额外返回值，自动带出值
      ...toastOption, // toast相关配置
      readonly: false, // 只读
      labelMapping: {}, // 标签
      successFlag: false,
      saveTcode: '', // 保存接口
    }
  },
  methods: {
    async init () {
      this.responseList = {
        ...this.responseList,
        ...this.extraResponseList,
        ...this.labelMapping,
      }
    },
    // 执行保存操作，返回值为Boolean，true表示保存成功
    async _save ({prevent = false, backStep} = {prevent: false}) {
      // 校验
      let validFieldList = Object.keys(this.validMessages)
      // if(validFieldList.length > 0) {
      //   console.log('validMessages-->', JSON.stringify(this.validMessages))
      //   return
      // }
      let key =
        validFieldList && validFieldList.length > 0
          ? validFieldList.find(key => this.isEmpty(this.responseList[key]))
          : ''
      if(key) {
        let obj = this.validMessages[key]
        this.toastText = obj.message
        this.showToast = true
        return false
      }
      await this.saveData()
    },
    // 保存
    async saveData () {
      let json = rmColnameFromJson(this.responseList)
      let params = {
        tcode: this.saveTcode,
        content: JSON.stringify(json),
      }
      this.$loading.show()
      await $appForm
        .hdAdd(params)
        .then(res => {
          this.$loading.hide()
          let resData = res.data || {}
          if(resData.code === '10') {
            this.$toast.show({
              type: 'success',
              content: '创建成功', // 默认为空字符串，不传将不显示文案
              position: 'middle', // 默认为middle，居中显示
            })
            this.successFlag = true
            this.toDetail(resData.result)
          } else {
            console.error(resData)
            this.$toast.show({
              type: 'error',
              content: resData.message || '请稍后重试', // 默认为空字符串，不传将不显示文案
              position: 'middle', // 默认为middle，居中显示
            })
          }
        })
        .catch(err => {
          this.$loading.hide()
          this.transFormErrorMsg(err)
        })
    },
    toDetail (entityId) {
      this.$router.replace({
        name: this.detailRouter,
        query: {id: entityId},
      })
    },
    // 返回
    goBack () {
      if(this.currentPopup) {
        this[this.currentPopup].show = false
      }
      this.successFlag = true
      this.$router.back()
    },
  },
  // 在跳转路由之前，检查页面有没有popup处于打开的状态，有的话，关闭popup
  beforeRouteLeave (to, from, next) {
    if(this.successFlag) {
      this.successFlag = false
      next()
      return
    }
    next(false)
    this.goBack()
  },
}

const mixinEdit = {
  mixins: [mixinCommon],
  props: {
    id: String,
    editResponseList: {
      type: Object,
      default () {
        return {}
      },
    }, // editResponseList默认值为{}
  },
  data () {
    return {
      // 默认值，需要在edit设置相应值
      headerTitle: '客户',
      primaryKey: 'accountid', // 主键，发送更新请求需要主键
      entityCode: 'account', // 实体编号
      // 内部变量，不必修改
      dataState: $CONST_STRING.DATA_STATE_INITIALIZING,
      responseList: JSON.parse(JSON.stringify(this.editResponseList)),
      ...toastOption, // toast相关配置
      readonly: false, // 只读
      successFlag: false,
      saveEditTcode: '',
    }
  },
  async mounted () {
    this.dataState = $CONST_STRING.DATA_STATE_INITIALIZED
  },
  methods: {
    async _save () {
      // 校验
      let validFieldList = Object.keys(this.validMessages)
      let key =
        validFieldList && validFieldList.length > 0
          ? validFieldList.find(key => this.isEmpty(this.responseList[key]))
          : ''
      if(key) {
        let obj = this.validMessages[key]
        this.toastText = obj.message
        this.showToast = true
        return false
      }
      await this.saveData()
    },
    // 保存
    async saveData () {
      let json = rmColnameFromJson(this.responseList)
      let params = {
        tcode: this.saveEditTcode,
        id: this.responseList.id,
        content: JSON.stringify(json),
      }
      this.$loading.show()
      await $appForm
        .hdUpdate(params)
        .then(res => {
          this.$loading.hide()
          let resData = res.data || {}
          if(resData.code === '10') {
            this.$toast.show({
              type: 'success',
              content: '修改成功', // 默认为空字符串，不传将不显示文案
              position: 'middle', // 默认为middle，居中显示
            })
            this.successFlag = true
            this.toDetail(this.responseList.id)
          } else {
            console.error(resData)
            this.$toast.show({
              type: 'error',
              content: resData.message || '请稍后重试', // 默认为空字符串，不传将不显示文案
              position: 'middle', // 默认为middle，居中显示
            })
          }
        })
        .catch(err => {
          this.$loading.hide()
          this.transFormErrorMsg(err)
        })
    },
    toDetail (entityId) {
      this.$router.back()
    },
    // 返回
    goBack () {
      if(this.currentPopup) {
        this[this.currentPopup].show = false
      }
      this.successFlag = true
      this.$router.back()
    },
  },
  // 在跳转路由之前，检查页面有没有popup处于打开的状态，有的话，关闭popup
  beforeRouteLeave (to, from, next) {
    if(this.successFlag) {
      this.successFlag = false
      next()
      return
    }
    next(false)
    this.goBack()
  },
}
const mixinList = {
  props: {},
  data () {
    return {}
  },
  async mounted () {
    this.addBodyMove()
  },
  destroyed () {
    console.log('KKK')
    this.removeBodyMove()
  },
  methods: {
    addBodyMove () {
      this.bodyMove = this.bodyMove.bind(this)
      document.body.addEventListener('touchmove', this.bodyMove, {
        passive: false,
      })
    },
    removeBodyMove () {
      document.body.removeEventListener('touchmove', this.bodyMove)
    },
    bodyMove (e) {
      console.log('****')
      e.preventDefault() // 阻止默认的处理方式(阻止下拉滑动的效果)
    },
  },
}
/**
 * @method 移除json中为_colname的字段
 * @param {*json参数} params
 */
function rmColnameFromJson (params) {
  let jsonParams = JSON.parse(JSON.stringify(params))
  for(let key in params) {
    if(key.indexOf('_colname') !== -1) {
      delete jsonParams[key]
    }
  }
  // 移除商机报备的查看正文字段 --字段内容过多导致保存报错问题
  if(jsonParams['new_content']) {
    delete jsonParams['new_content']
  }
  return jsonParams
}

export {uuid, mixinDetail, mixinNew, mixinEdit, mixinCommon, mixinList}



// WEBPACK FOOTER //
// ./src/utils/util.js